import React, { useState, useEffect } from "react";

import { DashboardLayout } from '../../Components/Layout/DashboardLayout';
import { notifications } from '../../Config/Data';

import NotificationCard from "../../Components/NotificationCard";

import './style.css'
import Loader from "../../Components/Loader";
import { useGetNotificationsQuery } from "../../Redux/Apis/Notification";

const Notifications = () => {

  const { data, isLoading } = useGetNotificationsQuery()

  const [notificationState, setNotificationState] = useState([])
  const [notificationType, setNotificationType] = useState('all')

  useEffect(() => {

    document.title = 'Landing List | Notifications';

    if (data) {
      setNotificationState(data)
    }

  }, [data])

  return (
    <div>
      <DashboardLayout>
        <div className="dashCard">
          <div className="container-fluid">
            <div className="row mb-4">
              <div className="col-12">
                <h2 className="mainTitle">Notifications</h2>
                <p className="text-muted mt-2 mb-0">A single place to review admin-facing alerts, system updates, and moderation activity.</p>
              </div>
            </div>
            <div className="row">
              {
                isLoading ? <Loader /> : (
                  notificationState?.length > 0 ? (
                    notificationState?.map((notification, index) => (
                      <>
                        <div className="col-12" key={index}>
                          <NotificationCard text={notification.text} date={notification.date} time={notification.time} read={notification.read} image={notification.userImage} />
                        </div>
                      </>
                    ))
                  ) : (
                    <div className="col-12">
                      <div className="empty">
                        <div className="emptyPanel">
                          <p className="emptyEyebrow">All caught up</p>
                          <h3>No new notifications</h3>
                          <p className="emptyDescription">When new alerts arrive for admins, they will show up here.</p>
                        </div>
                      </div>
                    </div>
                  )
                )
              }
            </div>
          </div>
        </div>


      </DashboardLayout>
    </div>
  )
}

export default Notifications;
